import NewsRow from './NewsRow';

export default NewsRow;
